module.exports = __webpack_public_path__ + "img/P150T_weapon_92.a7eb4934.png";